export enum TripRequestLogStatus {
    SUCCESS = 'success',
    FAILURE = 'failure',
}
